export default __webpack_public_path__ + "static/media/4-cheese.90e109ab.png";